import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import s from 'src/components/CapBoxNew/CapBoxHeaderNew/CapboxHeadernew.styles';

export const CapBoxAssessmentInformation = ({ auditStartAt, auditEndAt, jobServices }) => {
  const { t } = useTranslation();
  
  const filteredAuditServices = (jobServices || []).filter(({ service }) => service.currentVersion?.serviceType?.name === 'Audit');
  const assessmentStandard = filteredAuditServices.filter((element, index, array) => {
    const elementIndex = array.findIndex((b) => element.service.assessmentStandard && element.service.assessmentStandard === b.service.assessmentStandard);
    return index === elementIndex;
  }).map(({service}) => service.assessmentStandard).join(", ");  
  const assessmentName = filteredAuditServices.map(({ service }) => service.assessmentName).join(", ");

  return <>
  <s.CapHeader>
    <s.CapHeaderTitle>{t('ASSESSMENT_INFORMATION')}</s.CapHeaderTitle>
    <s.CapHeaderTable>
      <s.CapHeaderColumn head>
        <span>{t('ASSESSMENT_NAME')}</span>
        <span>{assessmentName}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('ASSESSMENT_TYPE')}</span>
        <span>{t('AUDIT')}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('ASSESSMENT_STANDARD')}</span>
        <span>{assessmentStandard}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('COLUMN_DATE_START')}</span>
        <span>{auditStartAt && moment(auditStartAt).format('DD-MMM-yyyy')}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('COLUMN_DATE_END')}</span>
        <span>{auditEndAt && moment(auditEndAt).format('DD-MMM-yyyy')}</span>
      </s.CapHeaderColumn>
      <s.CapHeaderColumn>
        <span>{t('DELIVERY_PARTY')}</span>
        <span>LRQA</span>
      </s.CapHeaderColumn>
    </s.CapHeaderTable>
  </s.CapHeader></>;
}
